const axios = require("axios");

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

api.defaults.headers.common.Authorization = `Token ${localStorage.getItem(
  "auth_token"
)}`;

/** Response interceptor - Caso a resposta do servidor for 401,
 * redireciona o usuário para tela de autenticação
 */
api.interceptors.response.use(
  response => {
    // Respostas 2xx
    return response;
  },
  error => {
    // Respostas diferentes de 2xx
    if (error.response) {
      const isAuthEndpoint = String(
        error.response.request.responseURL
      ).endsWith("/auth/");

      if (error.response.status === 401 && !isAuthEndpoint) {
        // Auth error
        localStorage.clear(); // Limpa os tokens

        setTimeout(() => {
          window.location.href = "/login"; // Redireciona para tela de login
        }, 200);
      }
    }
    return Promise.reject(error);
  }
);

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js